<template>
  <v-card
    class="card-chart afrus-card"
    :style="{ color }"
    :width="400"
    :height="120"
  >
    <div
      class="card-content"
      style="display: flex; flex-direction: column; justify-content: space-between; height: 100%;"
    >
      <div class="card-title">
        {{ title }}
        <v-icon :color="color">{{ icon }}</v-icon>
      </div>
      <div class="d-flex flex-row">
        <div class="card-value" :style="{ color }">
          {{ value }}
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ListCard",
  props: {
    title: { type: String, required: true },
    value: { type: Number, required: true },
    icon: { type: String, required: true },
    color: { type: String, required: false, default: "primary" }
  }
};
</script>

<style lang="scss" scoped>
.card-chart {
  border-radius: 12px !important;

  &-tooltip-content {
    opacity: 1 !important;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.25);
    .caption {
      color: rgba(130, 130, 130, 1);
    }
  }
}

.afrus-card {
  &.card--not-click {
    cursor: default;
    &:focus:before {
      opacity: 0;
    }
  }

  &.card--active {
    background: #f4f9ff;
    box-shadow: 0px 6px 6px rgba(62, 94, 142, 0.16);
  }

  /* display: grid;
      grid-template-columns: repeat(2, 1fr);
      align-items: center; */
  padding: 16px 20px;
  // min-width: 232px;
  width: 100%;

  box-shadow: 0px 10px 10px #f1f3f6;
  border: 1px solid #d0d3db;

  .card-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: var(--fontBase);
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.024em;
    color: var(--black-medium-opacity);
  }

  .card-percentage {
    margin: 4px 0 10px 0;

    .circle {
      font-family: var(--fontBase);
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.03em;
      padding: 1px 4px;
      border-radius: 50%;
    }

    font-family: var(--fontBase);
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.024em;
    color: var(--black-low-opacity);
  }

  .card-value {
    font-family: var(--fontBase);
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 125%;
    letter-spacing: 0.0072em;
    color: var(--black-medium-opacity);
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }

  .card-image {
    margin: 0 auto;
  }

  .card-simple-percent {
    margin: 12px 0 0 5px;
    font-family: var(--fontBase);
    font-style: normal;
    overflow-wrap: break-word;
    word-wrap: break-word;
    color: #828282;
  }

  &.white--text {
    .card-title,
    .card-value,
    .card-percentage {
      color: white;
    }
  }
}
</style>
